import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { contactInfo, socialIcons } from '../data';
import { FiSend } from 'react-icons/fi';
import { useForm } from 'react-hook-form';
import {
  Button,
  Col,
  ColInfo,
  Container,
  Form,
  FormControl,
  Info,
  Row,
  StyledContact,
  Error,
  Social,
} from './styles/Contact.styled';
// import { Heading } from './styles/SharedStyles';

const Contact = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const form = useRef();

  const submitHandler = (data) => {
    console.log(data);
    emailjs
      .sendForm(
        'service_0dp34rp',
        'template_8or8agi',
        form.current,
        'CSzgTHFQ9-dlCqoyz'
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    reset();
  };

  return (
    <StyledContact id="contact">
      <Container>
        <Row>
          <Col>
            {/* <Heading>Get in touch</Heading> */}
            <Form ref={form} onSubmit={handleSubmit(submitHandler)}>
              <FormControl>
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className={errors.name && 'invalid'}
                  {...register('name', { required: 'Name is required' })}
                />
                {errors.name && <Error>{errors.name.message}</Error>}
              </FormControl>

              <FormControl>
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  name="email"
                  className={errors.email && 'invalid'}
                  {...register('email', {
                    required: 'Email is required',
                    pattern: {
                      value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                      message: 'Invalid email address',
                    },
                  })}
                />
                {errors.email && <Error>{errors.email.message}</Error>}
              </FormControl>

              <FormControl>
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  className={errors.message && 'invalid'}
                  {...register('message', {
                    required: 'Message is required',
                  })}
                />
                {errors.message && <Error>{errors.message.message}</Error>}
              </FormControl>
              <Button type="submit">
                <FiSend /> Send Message
              </Button>
            </Form>
          </Col>
          <ColInfo>
            <h2>Let's work together on your next project.</h2>
            <p>
              I'm always happy to hear about exciting opportunities, join in
              interesting conversations, and build valuable connections. Let's
              connect!
            </p>
            <small>
              You can fill out the form or contact me via email or phone number
            </small>
            <Info>
              {contactInfo.map((item, i) => {
                return (
                  <li key={i}>
                    {item.icon}
                    <span>{item.text}</span>
                  </li>
                );
              })}
            </Info>
            <small>Find me Elsewhere</small>
            <Social>
              {socialIcons.map((item, i) => {
                return (
                  <li key={i}>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={item.text}
                    >
                      {item.icon}
                    </a>
                  </li>
                );
              })}
            </Social>
          </ColInfo>
        </Row>
      </Container>
    </StyledContact>
  );
};

export default Contact;
